import { useCallback, useContext } from 'react';

import { AccessContext } from '@/contexts/AccessContext';
import { WORKFLOW_CATEGORY_DETAIL_MODULES } from '@/lib/modules';

/**
 * useWorkflowDetailGate returns whether the session may open the detail of a
 * workflow item of the given category. A dunning item opens the dunning drawer,
 * which reads `GET /dunning/workflows/:id` (`billing` only), so a
 * `workflows`-only role sees the row but not its detail (#1691).
 *
 * Like `useModuleGate`, the gate is UX only and is open outside an
 * `AccessProvider`.
 */
export function useWorkflowDetailGate(): (category: string | null | undefined) => boolean {
  const context = useContext(AccessContext);
  return useCallback(
    (category) => {
      const modules = WORKFLOW_CATEGORY_DETAIL_MODULES[category ?? ''];
      if (!modules || !context) return true;
      return context.isAdmin || modules.some(context.hasModule);
    },
    [context],
  );
}
